import { BUN_PUBLIC_IMAGE_BASE_URL } from "@/env.json";
const SIWMALogo = BUN_PUBLIC_IMAGE_BASE_URL + "/logos/siwma.png";
const FIRCLogo = BUN_PUBLIC_IMAGE_BASE_URL + "/logos/firc.png";

const workExperience = [
  {
    title: "Product Delivery Manager  –  Intern",
    company: "Government Technology Agency (GovTech)",
    duration: "Sep 2023 - May 2024",
    logo: "https://isomer-user-content.by.gov.sg/85/06d6b95f-fc6b-418d-8b08-9efa88790822/GovTech%20Inline%20Logo_V3_no%20bg.gif",
    content: [
      "#### Product Management",
      "- Supported delivery of a **WOG CRM**, ensuring a **smooth launch** and that timelines are met, after **two prior delays**.",
      "- **Owned and managed** delivery focus on a complex **multi-agency** feature with **frequent requirement changes**.",
      "- Regularly reasoned through **edge cases** and **system behaviour** to clarify **ambiguous requirements** for engineers.",
      "- Regularly **coordinated alignment** across engineers, product owners, and **time-sensitive stakeholders**.",
      "- Conducted **user acceptance testing** and **contextual inquiry** with onboarding agencies.",
      "- Translated user and stakeholder feedback into **prioritised backlog updates**.",
      "#### Other Contributions",
      "- Maintained clear **project documentation** and shared resources.",
      "- Conducted **handovers** and **onboarding** to preserve delivery momentum as the team evolved.",
    ],
    techStack: [
      "Agile",
      "Scrum",
      "Jira",
      "Notion",
      "Figma",
      "Confluence",
      "UAT",
      "Contextual Inquiry",
      "Product Management",
      "Stakeholder Management",
    ],
  },
  {
    title: "Full-stack Engineer",
    company: "Singapore Iron Works Merchant Association (SIWMA) ",
    duration: "Nov 2022 - Sept 2023",
    logo: SIWMALogo,
    content: [
      "#### Product Management",
      "- **Led a team of 7** in conjunction with 2 other teams to develop a wholesale marketplace in **Typescript** using **NextJS**, **TailwindCSS**, **React**, **Prisma** and **DaisyUI**",
      "- Regularly **conducted** alignment sessions with the client to **gather requirements** and demonstrate new features",
      "- Regularly **led** sprint ceremonies including **sprint planning**, **daily standups** and **sprint retrospectives** to ensure smooth delivery of features",
      "#### Built Multiple Libraries",
      "- Developed a **fully-fledged, plug-and-play** NextJS **error handling middleware** to standardise error handling across the entire codebase",
      "- Developed **both** frontend and backend **API clients** to standardise communication between services and ensure **RESTful** best practices",
      "- Built **custom** **Zod** schema validation **middlewares** to ensure **type safety**",
      "- Built **custom** **react-form** add-ons for standardised **form validation** across the codebase, with **tight integration** to our error handling middleware",
      "- Made development **simpler**, **easier**, and **more efficient** for the entire engineering team",
      "#### Other Technical Contributions",
      "- Implemented our own **OAuth 2.0** authentication server using **NextAuth**, including **access token** issuance and **refresh token** rotation",
      "- Designed the **database architecture** for **PostgreSQL** on CockroachDB, and the overall **system architecture**",
      "- Wrote tests using **Jest** to ensure code quality and prevent regressions",
      "- Wireframed desktop & mobile UI interfaces using **Figma** in accordance with SGDS standards",
      "- Helped to build a full **UMS** and **CMS** which allows administrators to manage all user accounts, company profiles, products, categories, etc.",
      "- Regularly held **peer-programming** sessions and **code reviews** to ensure **high code quality** and **knowledge sharing** within the team",
    ],
    techStack: [
      "Typescript",
      "NextJS",
      "React",
      "TailwindCSS",
      "PostgreSQL",
      "Prisma",
      "NextAuth",
      "OAuth 2.0",
      "Zod",
      "react-form",
      "react-query",
      "DaisyUI",
      "Jest",
      "Figma",
      "System Design",
      "Agile",
      "Scrum",
      "AWS",
    ],
  },
  {
    title: "Full-stack Engineer",
    company: "Food Innovation Resource Centre",
    duration: "Apr 2022 - Sep 2022",
    logo: FIRCLogo,
    content: [
      "#### Developed a Food Production Monitoring and Recommendation System",
      "- **Led a team of 6** to develop a **food production monitoring** and **recommendation system** using **Typescript**, **NextJS**, **React**, **Redux** and **ChartJS**",
      "- Wrote comprehensive tests using **Jest**",
      "- **Designed and built** a fully specified REST backend using **Express**, **Prisma** and **PostgreSQL**",
      "- Developed algorithms to **predict and recommend** production schedules based on current and past production availability",
      "- Developed functionality to **identify anomalies** in production to provide **issue-specific feedback** and **suggestions**",
      "- Configured and deployed the system on a Ubuntu **AWS EC2** instance",
    ],
    techStack: [
      "Typescript",
      "NextJS",
      "React",
      "Redux",
      "TailwindCSS",
      "react-query",
      "ChartJS",
      "Express",
      "Prisma",
      "PostgreSQL",
      "Jest",
      "AWS EC2",
    ],
  },
];

export { workExperience };
